import { cn } from "@/utils/cn";

// Figma: https://www.figma.com/design/HJIp5P6tyeFrUd7ODqeWdM/-PROD--Fertility-V?node-id=4869-26818

type NumberBadgeProps = {
  /** The step's position, 1-based. */
  number: number;
  /** Layout only. */
  className?: string;
};

// Display component, no ref forwarded. See ui/README.md.
export const NumberBadge = ({ number, className }: NumberBadgeProps) => (
  <span
    className={cn(
      "flex size-ds-icon-large shrink-0 items-center justify-center rounded-ds-corner-full bg-ds-all-colors-pine text-ds-ui-elements-white ds-header-subheader",
      className
    )}
  >
    {number}
  </span>
);
